<template>
  <div
    class="px-12px lg:px-35 w-full lg:w-card_large border-2 rounded-xl border-skin-gray py-10px lg:py-17px"
  >
    <div class="grid grid-cols-invoice_card items-center text-skin-black">
      <div>
        <p class="inline-block  text-s lg:text-big font-bold text-skin-secondary">
          Pedido {{ pedido }}
        </p>

        <div class="inline-block lg:flex items-center">
          <p
            class="text-s lg:text-m font-medium mr-40px inline-block text-skin-secondary"
          >
            {{ newdate }}
          </p>

          <p
            class=" font-bold text-xm lg:text-big inline-block text-skin-secondary"
          >
            Total: ${{ amount }}
          </p>
        </div>
      </div>
      <Download class="cursor-pointer" />
    </div>
  </div>
</template>

<script>
import Download from "./icons/Download.vue";
export default {
  components: {
    Download,
  },
  data() {
    return {
      newdate: "",
    };
  },
  props: {
    amount: {
      default: null,
    },
    pedido: {
      default: null,
    },
    date: {
      default: null,
    },
  },
  mounted() {
    const unixTimestamp = Date.parse(this.date);

    const dateObject = new Date(unixTimestamp);

    dateObject.toISOString()

     var options = {
        year: "numeric",
        month: "2-digit",
        day: "numeric"
    };

    this.newdate = dateObject.toLocaleString("es-VE", options);
  },
};
</script>
